// extracted by mini-css-extract-plugin
export default {"container":"InfoPage_container__G1esb","titleWrapper":"InfoPage_titleWrapper__gdDOj","bodyWrapper":"InfoPage_bodyWrapper__rNSpp"};